import { render, staticRenderFns } from "./userHeatmap.vue?vue&type=template&id=2ed5ae4d&"
import script from "./userHeatmap.vue?vue&type=script&lang=js&"
export * from "./userHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports